import React from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
/* REDUX */
import { connect } from 'react-redux'
import { loadLikes, likeReport } from '../../actions/attributes'

class AttrLiked extends React.Component {
	constructor(props) {
		super(props)
		this.state = { 
			userLiked: false
		}
		this.handleLike = this.handleLike.bind(this)
	}
	
	componentWillMount() {
		this.setState({
			userLiked: this.props.userLiked
		})
	}
	
	componentWillReceiveProps(nextProps) {
		this.setState({
			userLiked: nextProps.userLiked
		})
	}
	
	handleLike(e) {
		e.preventDefault()
		const { authenticated, onLogin, likeReport, report_id } = this.props
		if (!authenticated) {
			onLogin()
			return
		}
		if (this.state.userLiked) {
			likeReport(report_id, 'unlike')
		} else {
			likeReport(report_id, 'like')
		}
	}
	
	render() {
		if (this.state.userLiked) {
			return (
				<button type="button" className="attr attr-s liked" onClick={ this.handleLike }>
					<span className="icon"><svg viewBox="0 0 576 512"><path d="M414.9 24C361.8 24 312 65.7 288 89.3 264 65.7 214.2 24 161.1 24 70.3 24 16 76.9 16 165.5c0 72.6 66.8 133.3 69.2 135.4l187 180.8c8.8 8.5 22.8 8.5 31.6 0l186.7-180.2c2.7-2.7 69.5-63.5 69.5-136C560 76.9 505.7 24 414.9 24z"></path></svg></span><span className="label">{ this.props.likesCount }</span></button>
			)
		} else {
			return (
				<button type="button" className="attr attr-s" onClick={ this.handleLike }>
					<span className="icon"><svg viewBox="0 0 576 512"><path d="M257.3 475.4L92.5 313.6C85.4 307 24 248.1 24 174.8 24 84.1 80.8 24 176 24c41.4 0 80.6 22.8 112 49.8 31.3-27 70.6-49.8 112-49.8 91.7 0 152 56.5 152 150.8 0 52-31.8 103.5-68.1 138.7l-.4.4-164.8 161.5a43.7 43.7 0 0 1-61.4 0zM125.9 279.1L288 438.3l161.8-158.7c27.3-27 54.2-66.3 54.2-104.8C504 107.9 465.8 72 400 72c-47.2 0-92.8 49.3-112 68.4-17-17-64-68.4-112-68.4-65.9 0-104 35.9-104 102.8 0 37.3 26.7 78.9 53.9 104.3z"></path></svg></span><span className="label">{ this.props.likesCount }</span></button>
			)
		}
	}
}

const loadData = ({ report_id, loadLikes }) => {
	loadLikes(report_id)
}

class AttrLike extends React.Component {
	
	componentWillMount() {
		loadData(this.props)
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.report_id !== this.props.report_id) {
			loadData(nextProps)
		}
	}
	
	render() {
		
		const { report_id, likes, commentsCount, user_id, authenticated, onLogin, likeReport } = this.props
		
		if (!likes) {
			return <div></div>
		}
		
		const likesCount = likes.length
		
		const userLiked = likes.indexOf(user_id) > -1 ? true : false

		return (
			<div className="react">
				<AttrLiked report_id={ report_id } likesCount={ likesCount } userLiked={ userLiked } authenticated={ authenticated } onLogin={ onLogin } likeReport={ likeReport } />
				<button className="attr attr-hide"><span className="icon"><svg viewBox="0 0 576 512"><path d="M288 32C129 32 0 125.1 0 240c0 49.3 23.7 94.5 63.3 130.2-8.7 23.3-22.1 32.7-37.1 43.1C15.1 421-6 433 1.6 456.5c5.1 15.4 20.9 24.7 38.1 23.3 57.7-4.6 111.2-19.2 157-42.5 28.7 6.9 59.4 10.7 91.2 10.7 159.1 0 288-93 288-208C576 125.1 447.1 32 288 32zm0 368c-32.5 0-65.4-4.4-97.3-14-32.3 19-78.7 46-134.7 54 32-24 56.8-61.6 61.2-88.4C79.1 325.6 48 286.7 48 240c0-70.9 86.3-160 240-160s240 89.1 240 160c0 71-86.3 160-240 160z"></path></svg></span><span className="label">{ commentsCount }</span></button>
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const report_id = ownProps.report_id
	const {
		likesById
	} = state
	const likesWrapper = likesById[report_id] || {}
	const likes = likesWrapper.likes
	return {
		report_id: report_id,
		likes,
		authenticated: state.auth.authenticated,
		user_id: state.auth.user_id || 0
	}
}

export default withRouter(connect(mapStateToProps, { loadLikes, likeReport })(AttrLike))


// WEBPACK FOOTER //
// ./src/components/Report/AttrLike.js